module.exports = __webpack_public_path__ + "media/images/rie-text-16248c3c.png";